import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { ResponsiveContainer, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar } from 'recharts';

const Chart = ({ data, ...rest }) => (
  <ResponsiveContainer {...rest} width="100%">
    <RadarChart height="300" width="100%" data={data}>
      <PolarGrid fontSize={20} />
      <PolarAngleAxis radius={125} dataKey="label" fontSize={16} />
      <PolarRadiusAxis angle={90} domain={[0, 20]} dy={6} dx={5} />
      <Radar dataKey="Score" stroke="#8BBE3F" fill="#E2EFCF" fillOpacity={0.6} />
    </RadarChart>
  </ResponsiveContainer>
);

class HealthIndexes extends PureComponent {
  static propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.string,
      score: PropTypes.number,
    })).isRequired,
  }
  render() {
    const { data } = this.props;

    return (
      <Fragment>
        <Chart data={data} className="db-ns dn" height={300} />
        <Chart data={data} aspect="1.5" height={250} className="db dn-ns flex items-center" />
      </Fragment>
    );
  }
}

export default HealthIndexes;
